// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as CpfValidation$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CpfValidation.bs.js";
import * as CnpjValidation$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CnpjValidation.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";

function PixPaymentInput(props) {
  var __fieldType = props.fieldType;
  var fieldType = __fieldType !== undefined ? __fieldType : "";
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userPixCNPJ);
  var setPixCNPJ = match$1[1];
  var pixCNPJ = match$1[0];
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userPixCPF);
  var setPixCPF = match$2[1];
  var pixCPF = match$2[0];
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userPixKey);
  var setPixKey = match$3[1];
  var pixKey = match$3[0];
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.sourceBankAccountId);
  var setSourceBankAccountId = match$4[1];
  var sourceBankAccountId = match$4[0];
  var inputRef = React.useRef(null);
  var validatePixKey = function (val) {
    if (val.length > 0) {
      return {
              value: val,
              isValid: true,
              errorString: ""
            };
    } else {
      return {
              value: val,
              errorString: ""
            };
    }
  };
  var validatePixCNPJ = function (val) {
    var isCNPJValid = CnpjValidation$OrcaPaymentPage.isValidCNPJ(val);
    if (isCNPJValid) {
      return {
              value: val,
              isValid: true,
              errorString: ""
            };
    } else if (val.length === 0) {
      return {
              value: val,
              errorString: ""
            };
    } else {
      return {
              value: val,
              isValid: false,
              errorString: localeString.pixCNPJInvalidText
            };
    }
  };
  var validatePixCPF = function (val) {
    var isCPFValid = CpfValidation$OrcaPaymentPage.isValidCPF(val);
    if (isCPFValid) {
      return {
              value: val,
              isValid: true,
              errorString: ""
            };
    } else if (val.length === 0) {
      return {
              value: val,
              errorString: ""
            };
    } else {
      return {
              value: val,
              isValid: false,
              errorString: localeString.pixCPFInvalidText
            };
    }
  };
  var match$5;
  switch (fieldType) {
    case "pixCNPJ" :
        match$5 = [
          localeString.pixCNPJLabel,
          setPixCNPJ,
          pixCNPJ,
          localeString.pixCNPJPlaceholder,
          14,
          validatePixCNPJ
        ];
        break;
    case "pixCPF" :
        match$5 = [
          localeString.pixCPFLabel,
          setPixCPF,
          pixCPF,
          localeString.pixCPFPlaceholder,
          11,
          validatePixCPF
        ];
        break;
    case "pixKey" :
        match$5 = [
          localeString.pixKeyLabel,
          setPixKey,
          pixKey,
          localeString.pixKeyPlaceholder,
          undefined,
          validatePixKey
        ];
        break;
    default:
      match$5 = [
        "",
        (function (param) {
            
          }),
        RecoilAtoms$OrcaPaymentPage.defaultFieldValues,
        "",
        undefined,
        (function (param) {
            return RecoilAtoms$OrcaPaymentPage.defaultFieldValues;
          })
      ];
  }
  var validationFn = match$5[5];
  var setValue = match$5[1];
  var validateAndSetPixInputValue = function (val) {
    setValue(function (param) {
          return validationFn(val);
        });
  };
  var onChange = function (ev) {
    var val = ev.target.value;
    var transformedVal;
    switch (fieldType) {
      case "pixCNPJ" :
          transformedVal = val.toUpperCase();
          break;
      case "pixCPF" :
          transformedVal = CardValidations$OrcaPaymentPage.clearSpaces(val);
          break;
      default:
        transformedVal = val;
    }
    validateAndSetPixInputValue(transformedVal);
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    validateAndSetPixInputValue(val);
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit) {
            if (pixKey.value === "") {
              setPixKey(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.errorString = localeString.pixKeyEmptyText;
                    return newrecord;
                  });
            }
            if (pixCNPJ.value === "") {
              setPixCNPJ(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.errorString = localeString.pixCNPJEmptyText;
                    return newrecord;
                  });
            }
            if (pixCPF.value === "") {
              setPixCPF(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.errorString = localeString.pixCPFEmptyText;
                    return newrecord;
                  });
            }
            if (sourceBankAccountId.value === "") {
              return setSourceBankAccountId(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = localeString.sourceBankAccountIdEmptyText;
                          return newrecord;
                        });
            } else {
              return ;
            }
          }
          
        }), [
        pixCNPJ.value,
        pixKey.value,
        pixCPF.value
      ]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(PaymentField$OrcaPaymentPage.make, {
              setValue: setValue,
              value: match$5[2],
              onChange: onChange,
              onBlur: onBlur,
              fieldName: match$5[0],
              name: fieldType,
              type_: fieldType,
              paymentType: "Payment",
              maxLength: match$5[4],
              placeholder: match$5[3],
              inputRef: inputRef
            });
}

var make = PixPaymentInput;

export {
  make ,
}
/* react Not a pure module */
